import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { ArrowRight, Zap } from 'lucide-react';

export default function ExitIntentDialog({ course, onClaim }) {
  const [open, setOpen] = useState(false);

  const trigger = useCallback((e) => {
    if (e.clientY > 8 || e.relatedTarget) return;
    if (sessionStorage.getItem('mm_exit_shown')) return;
    sessionStorage.setItem('mm_exit_shown', '1');
    setOpen(true);
  }, []);

  useEffect(() => {
    if (!course) return;
    document.addEventListener('mouseout', trigger);
    return () => document.removeEventListener('mouseout', trigger);
  }, [course, trigger]);

  if (!course) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="exit-intent-dialog" className="bg-[#0B0B0B] border border-[#C6A97C]/30 text-white max-w-md p-8 [&>button]:text-white">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 bg-[#C6A97C]/15 text-[#C6A97C] rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-widest mb-5">
            <Zap className="w-3.5 h-3.5" /> Wait — before you go
          </span>
          <h2 className="text-3xl font-bold leading-tight mb-3" style={{ fontFamily: 'Clash Display' }}>
            Your pain won't
            <br />
            fix itself.
          </h2>
          <p className="text-gray-400 mb-6">
            Get the full {course.duration_weeks || 6}-week {course.title} program — the launch price ends Sunday.
          </p>
          <div className="flex items-baseline justify-center gap-3 mb-6">
            <span className="text-xl text-gray-500 line-through" style={{ fontFamily: 'Clash Display' }}>$89</span>
            <span className="text-5xl font-bold text-[#C6A97C]" style={{ fontFamily: 'Clash Display' }}>$49</span>
            <span className="text-sm text-gray-500">once-off</span>
          </div>
          <Button
            data-testid="exit-intent-cta-btn"
            onClick={() => {
              setOpen(false);
              onClaim({ package_type: 'course', course_id: course.id, title: course.title, price: course.price, display_price: '$49' });
            }}
            className="w-full bg-[#D9C7A3] text-[#0B0B0B] hover:bg-[#C6A97C] rounded-full py-7 text-lg font-bold"
          >
            Claim My $49 Spot <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          <button
            data-testid="exit-intent-dismiss-btn"
            onClick={() => setOpen(false)}
            className="mt-4 text-sm text-gray-500 hover:text-gray-300 underline"
          >
            No thanks, I'll keep living with the pain
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
